<template>
    <div class="body">
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                style="direction: rtl; text-align: center"
                :timeout="1500"
        >
            {{ message }}
        </v-snackbar>

        <DataTable
                :url="url"
                :titles="titles"
                :fields-hidden-add="['id' , 'created_at', 'updated_at', 'deleted_at']"
                :fields-hidden-main="['created_at', 'updated_at', 'deleted_at']"
                :fields-extra-add="fieldsExtraAdd"
                :enableEdit="false"
                :disableSearch="true"
        />

    </div>

</template>


<script>
    import DataTable from "@/components/monaco/DataTable";
    export default {
        name: "ContractTemplate",
        components: {DataTable},
        data() {
            return {
                snackbar: false,
                message: "",
                valid: true,
                lazy: false,
                loading: false,
                url: "contract_template",
            }
        },
        computed: {
            titles() {
                return {
                    id: '#',
                    name: this.$t("seasonalPage.name"),
                    percentage: this.$t("seasonalPage.percentage"),
                    per_hour: this.$t("seasonalPage.perHour"),
                    per_km: this.$t("seasonalPage.perKm"),
                    per_booking: this.$t("seasonalPage.perBooking")
                }
            },
            fieldsExtraAdd() {
                return {
                    name: 'v-text-field',
                    percentage: 'v-text-field',
                    per_hour: 'v-text-field',
                    per_km: 'v-text-field',
                    per_booking: 'v-text-field',
                }
            },
        }

    }
</script>

<style scoped>

</style>
